export enum Layout {
  DEFAULT,
  PUBLIC
}
